import { VectorTileSource } from '../source/vector_tile_source';
import { RasterTileSource } from '../source/raster_tile_source';
import { RasterDEMTileSource } from '../source/raster_dem_tile_source';
import { GeoJSONSource } from '../source/geojson_source';
import { VideoSource } from '../source/video_source';
import { ImageSource } from '../source/image_source';
import { CanvasSource } from '../source/canvas_source';
const registeredSources = {};
/**
 * Creates a tiled data source instance given an options object.
 *
 * @param id - The id for the source. Must not be used by any existing source.
 * @param specification - Source options, specific to the source type (except for `options.type`, which is always required).
 * @param source - A source definition object compliant with
 * [`maplibre-gl-style-spec`](https://maplibre.org/maplibre-style-spec/#sources) or, for a third-party source type,
  * with that type's requirements.
 * @param dispatcher - A {@link Dispatcher} instance, which can be used to send messages to the workers.
 * @returns a newly created source
 */
export const create = (id, specification, dispatcher, eventedParent) => {
    const Class = getSourceType(specification.type);
    const source = new Class(id, specification, dispatcher, eventedParent);
    if (source.id !== id) {
        throw new Error(`Expected Source id to be ${id} instead of ${source.id}`);
    }
    return source;
};
export const getSourceType = (name) => {
    switch (name) {
        case 'geojson':
            return GeoJSONSource;
        case 'image':
            return ImageSource;
        case 'raster':
            return RasterTileSource;
        case 'raster-dem':
            return RasterDEMTileSource;
        case 'vector':
            return VectorTileSource;
        case 'video':
            return VideoSource;
        case 'canvas':
            return CanvasSource;
    }
    return registeredSources[name];
};
export const setSourceType = (name, type) => {
    registeredSources[name] = type;
};
//# sourceMappingURL=source.js.map